export const zoom_isv_direct_join = "zoom_isv_direct_join";
export const METADATA = "metadata";
export const METADATA_ZOOM_ISV_DIRECT_JOIN = "metadata.zoom_isv_direct_join";
